import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=7fbc2cd9&scoped=true&"
import script from "./UserDashboard.vue?vue&type=script&lang=ts&"
export * from "./UserDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=7fbc2cd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc2cd9",
  null
  
)

export default component.exports